import { combineEpics } from "redux-observable";
import uploadCompress from "./upload-form-effect";

const formEffects = combineEpics(uploadCompress);

export default formEffects;
